export const excerpt = (text, max) => {
  const clean = (text || '').replace(/\s+/g, ' ').trim();
  if (clean.length <= max) return clean;
  const slice = clean.slice(0, max);
  const boundary = slice.lastIndexOf(' ');
  return `${slice.slice(0, boundary > max / 2 ? boundary : max)}…`;
};

export const wrapText = (context, text, width, font) => {
  context.font = font;
  const lines = [];
  let line = '';
  for (const word of (text || '').split(/\s+/)) {
    if (context.measureText(word).width > width) {
      if (line) { lines.push(line); line = ''; }
      for (const char of word) {
        if (line && context.measureText(line + char).width > width) { lines.push(line); line = ''; }
        line += char;
      }
    } else if (line && context.measureText(`${line} ${word}`).width > width) {
      lines.push(line); line = word;
    } else line += (line ? ' ' : '') + word;
  }
  if (line) lines.push(line);
  return lines;
};

export const paintLines = (context, lines, x, y, font, lineHeight, color = '#111', align = 'left') => {
  context.font = font; context.fillStyle = color; context.textAlign = align; context.textBaseline = 'top';
  lines.forEach((line, i) => context.fillText(line, x, y + i * lineHeight));
};